const GENERIC_LINK_LABELS = new Set(['learn more', 'read more', 'more']);

function toTitleCase(value: string) {
	return value
		.split(/[\s-]+/)
		.filter(Boolean)
		.map((part) => part.charAt(0).toUpperCase() + part.slice(1))
		.join(' ');
}

function getLinkContext(url?: string) {
	if (!url) return '';

	try {
		const parsedUrl = new URL(url, 'https://example.invalid');
		const pathSegments = parsedUrl.pathname.split('/').filter(Boolean);
		const lastSegment = pathSegments.at(-1);

		return lastSegment ? toTitleCase(decodeURIComponent(lastSegment)) : '';
	} catch {
		return '';
	}
}

export function getDescriptiveLinkText({
	label,
	context,
	url,
}: {
	label?: string;
	context?: string;
	url?: string;
}) {
	const trimmedLabel = label?.trim() ?? '';

	if (!trimmedLabel) return '';
	if (!GENERIC_LINK_LABELS.has(trimmedLabel.toLowerCase())) return trimmedLabel;

	const subject = context?.trim() || getLinkContext(url);
	return subject ? `Learn More About ${subject}` : trimmedLabel;
}
